// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__19Qap","log":"ModalInventoryLogs_log__YHWuz","date":"ModalInventoryLogs_date__vtahJ","userName":"ModalInventoryLogs_userName__dhyKi"};